module.exports={
    header: {
        icon:{
            icon:'/static/images/store_04.png',
            // store:'/static/images/store_06.png',
            // system:'/static/images/store_08.png',
            // template:'/static/images/store_10.png'
        },
        store:'店舗',
        system:'システム',
        template:'テンプレート',
        personInfo:'個人情報',
        systemMsg:'バージョン情報',
        quit:'やめる',
        switch:'中国語/英語/日本語',
        dialogTitle:'バージョン',
        dialog:{
            sure:'確定',
            cancel:'キャンセル'
        },
        hintMsg:{
            queryFail:'ユーザー情報のクエリに失敗しました',
            frontendVersion:'フロントエンドバージョン：{version}',
            backendVersion:'バックエンドバージョン：{version}'
        },
        quitMsg: '終了しますか'
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/ja/Header.js